module.exports = __webpack_public_path__ + "icon_talous.45fd9925af038930c021.svg";